import {LucideIcon} from "lucide-react"
import {cn} from "@/lib/utils"

export type CtaButtonIconProps = {
    icon: LucideIcon
    className?: string
    resolvedActiveClass?: string
    baseClass?: string
    ariaHidden?: boolean
}

/**
 * Renders a LucideIcon with unified base classes and optional resolvedActiveClass applied.
 * - `baseClass` lets callers adjust size/min-size (default matches existing small icons).
 * - `resolvedActiveClass` is applied first so active utilities (like `!stroke-*`) propagate to SVG children.
 */
export function CtaButtonIcon({
    icon: Icon,
    className = "",
    resolvedActiveClass = "",
    baseClass = "fill-none stroke-2 h-6 w-6",
    ariaHidden = true,
}: CtaButtonIconProps) {
    return (
        <Icon
            className={cn(baseClass, resolvedActiveClass ? resolvedActiveClass : "stroke-current", className, "cta-button-icon block align-middle")}
            aria-hidden={ariaHidden}
        />
    )
}
